module.exports = __webpack_public_path__ + "i18n/fr.cd4d9487e7316c99d65d34da634b3afe.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/fr.json
// module id = 1285
// module chunks = 60